<div class="xcm-notification-stack" aria-live="polite" aria-atomic="true">
  @for (alert of alerts; track alert) {
    <ngb-toast [autohide]="false" [class]="toastClass(alert)">
      <div class="xcm-notification-content">
        <div class="xcm-notification-message">
          @if (alert.code) {
            <strong>{{ alert.code }}</strong>
          }
          {{ alert.message }}
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="removeAlert(alert)"></button>
      </div>
    </ngb-toast>
  }
</div>